import type { ComponentType } from 'react'
import { FileText, Globe, Link2 } from 'lucide-react'
import { useMessages } from '@/i18n'
import { messages } from './messages'

export type CourseCardStatus = 'draft' | 'published' | 'link'

const META = {
  draft: { icon: FileText, label: 'statusDraft' },
  published: { icon: Globe, label: 'statusPublished' },
  link: { icon: Link2, label: 'statusLink' },
} as const

/** Статус курса по тем же правилам, что вкладки «Мои курсы» (`dashboardFilter`). */
export const courseCardStatus = (course: {
  isPublished?: boolean | null
  isPublic?: boolean | null
}): CourseCardStatus =>
  !course.isPublished ? 'draft' : course.isPublic === false ? 'link' : 'published'

/** Чип статуса поверх обложки карточки «Мои курсы». */
export const CourseStatusChip = ({ status }: { status: CourseCardStatus }) => {
  const m = useMessages(messages)
  return <CoverChip icon={META[status].icon} label={m[META[status].label]} />
}

/** «Жидкое стекло» поверх обложки — общая пилюля карточек курсов и инструкций.
 *  white by design: стекло лежит на картинке обложки, а не на поверхности темы.
 *  Кегль — от ширины карточки-контейнера (`cqw`), размеры в `em` — растут вместе с ним. */
export const CoverChip = ({
  icon: Icon,
  label,
}: {
  icon: ComponentType<{ className?: string }>
  label: string
}) => {
  return (
    <span className="glass-chip flex items-center gap-[0.5em] rounded-full px-[0.85em] py-[0.35em] text-[clamp(0.75rem,4cqw,0.9375rem)] font-medium leading-none">
      <Icon className="size-[1.17em] shrink-0" />
      {label}
    </span>
  )
}
